// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3343":"css/admin-app.6630","7205":"css/app.6630"}[chunkId] + ".css";
};